export enum SignatureTabEnum {
    DigitalStamp = 'DigitalStamp',
    MouseOrTouch = "MouseOrTouch",
    UploadPicture = 'UploadPicture',
}